// extracted by mini-css-extract-plugin
export var lg = "_l-7";
export var md = "_l-6";
export var placeholderContainer = "_l-1";
export var placeholderIcon = "_l-2";
export var productImage = "_l-0";
export var sm = "_l-5";
export var xs = "_l-4";
export var xxs = "_l-3";